export default class {
  // gère les réponses retournées par les WS
  static manageError (error) {
    // dans le cas ou le modèle n'est pas valide
    if (error.response.status === 400) {
      let message = global.dataInit.resources.InvalidFormFieldsText
      if (error.response.data.errors != null) {
        Object.keys(error.response.data.errors).forEach(key => {
          message += '<br/>' + error.response.data.errors[key]
        })
      }
      error.response.data = {
        message: message
      }
    }
    // dans le cas ou la requete n'est pas authentifiée (401)
    if (error.response.status === 401) {
      // message a l'utilisateur pour indiquer que la session est perdue
      error.response.data = {
        message: global.dataInit.resources.SessionLostText
      }
      // on redirige vers la page de Login au bout de 3s
      window.setTimeout(function () {
        window.location = '/login'
      }, 3000)
    }
  }
}
